import { PageRouteBuilder } from "@common/route/page-route-builder";
import { MoveBoardPageComponent } from "./move-board-page.component";

export const moveBoardPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-move-board-page", MoveBoardPageComponent)
    .requiresLogin()
    .atUrl("/tools/move-board")
    .withTitle("Move Board")
    .build();
